/**
 * API路径配置
 * 集中管理所有API相关配置
 */

// 根据当前URL路径自动判断是否使用/demo路径前缀
const isInDemoPath = window.location.pathname.startsWith('/demo');

// 默认API路径
let baseApiUrl = '/api';

// 如果当前在/demo路径下，自动添加/demo前缀
if (isInDemoPath) {
  baseApiUrl = '/demo/api';
}

// 如果环境变量中设置了API路径且不为空，则使用环境变量中的值
if (process.env.VUE_APP_BASE_API && process.env.VUE_APP_BASE_API.trim() !== '') {
  baseApiUrl = process.env.VUE_APP_BASE_API;
}

// 特殊处理流向数据API，确保它们可以正确发送
console.log('原始API基础路径:', baseApiUrl);

// 导出API配置
export default {
  baseUrl: baseApiUrl,
  timeout: 15000,
  // 添加专门的流向数据API路径配置
  flowDataBaseUrl: '/api',
  rawDataBaseUrl: '/api'
};

// 便于调试
console.log('API路径配置:', { 
  baseUrl: baseApiUrl, 
  isInDemoPath,
  flowDataBaseUrl: '/api',
  rawDataBaseUrl: '/api'
}); 